module.exports = __webpack_public_path__ + "a0537cec38a1151b2793b346610fce23.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/header/default-avata.jpg
// module id = ./assets/images/header/default-avata.jpg
// module chunks = 0